import { toast as sonnerToast } from 'sonner';

export function toast(type: 'success' | 'error' | 'warning' | 'info', msg: string) {
  switch (type) {
    case 'success':
      return sonnerToast.success(msg);
    case 'error':
      return sonnerToast.error(msg);
    case 'warning':
      return sonnerToast.warning(msg);
    case 'info':
      return sonnerToast.info(msg);
    default:
      return sonnerToast(msg);
  }
}
